import { z } from "zod";

// Bus aramasındaki gibi, t fonksiyonu ile dinamik şema oluştur.
export const createFerrySearchSchema = (t) =>
  z
    .object({
      departureCity: z
        .object({
          value: z.string(),
          label: z.string(),
        })
        .nullable()
        .refine((city) => city !== null, {
          message: t("ferry.searchErrorsDepartureRequired"),
        }),
      returnCity: z
        .object({
          value: z.string(),
          label: z.string(),
        })
        .nullable()
        .refine((city) => city !== null, {
          message: t("ferry.searchErrorsReturnRequired"),
        }),
    })
    .refine(
      (data) => {
        if (data.departureCity && data.returnCity) {
          return data.departureCity.value !== data.returnCity.value;
        }
        return true;
      },
      {
        message: t("ferry.searchErrorsSameDepartureReturn"),
        path: ["returnCity"], // Hata mesajını nereye alanında göster
      },
    );

export default createFerrySearchSchema;
